import { getRndKey } from './utils';

export const pageize = (route, data, current, itemsPerPage) => {
    const perPage = parseInt(itemsPerPage);
    const result = {
        current: parseInt(current),
        data: data,
        itemCount: data.length,
        pageCount: data.length > perPage ? parseInt(Math.ceil(data.length / perPage)) : 1,
        start: 1,
        perPage: perPage,
        end: 1,
        route: route,
    };
    result.current = result.current < 1 ? 1 : result.current;
    result.current = result.current > result.pageCount ? result.pageCount : result.current;

    result.end = result.pageCount;

    if (data.length > perPage) {
        result.data = data.slice(
            (result.current - 1) * perPage,
            (result.current - 1) * perPage + perPage,
        );
    }
    return result;
};

export const makePager = (current, total, perPage) => {
    const pages = total > perPage ? parseInt(Math.ceil(total / perPage)) : 1;
    const result = {
        current: parseInt(current),
        start: 1,
        end: pages,
        perPage: perPage,
        key: getRndKey(),
    };
    if (result.current < 1) {
        result.current = 1;
    }
    if (result.current > result.end) {
        result.current = result.end;
    }
    return result;
};

export const usePaginator = () => {
    return {
        pageize: pageize,
        makePager: makePager,
    };
};

export default usePaginator;
